import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Код версии контроля',
    key: 'ctrl_vers_code',
    width: 250,
  },
  // {
  //   title: 'Наименование версии контроля',
  //   key: 'ctrl_vers_name',
  //   width: 250,
  // },
  {
    title: 'Фильтр по шагам контроля',
    key: 'step_num_out',
    width: 250,
  },
  {
    key: 'org_code',
    hidden: true,
  },
];
